import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-wrap items-center"
}
const _hoisted_3 = { class: "mb-0.5 mr-4" }
const _hoisted_4 = {
  key: 2,
  class: "w-full md:w-1/2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col mt-4 space-y-1 text-sm md:space-y-0 md:flex-row md:space-x-4"
}
const _hoisted_6 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-sm material-icons-outlined text-muted" }, " visibility ", -1)
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-sm material-icons-outlined text-muted" }, " question_answer ", -1)
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = {
  key: 2,
  class: "mt-8 sub-slot-container"
}
const _hoisted_13 = { class: "text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Exercise = _resolveComponent("Exercise")!
  const _component_ClozeExercise = _resolveComponent("ClozeExercise")!
  const _component_ParticipationSlotAssessment = _resolveComponent("ParticipationSlotAssessment")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_AbstractEventParticipationSlot = _resolveComponent("AbstractEventParticipationSlot", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'pl-4': _ctx.subSlot })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
					'flex flex-col space-y-4':
						_ctx.allowEditAssessment || _ctx.showAssessmentCard || _ctx.showHintButton,
					'md:flex-row md:space-x-8 md:space-y-0': true || !_ctx.subSlot,
				})
      }, [
        (_ctx.exercise.exercise_type !== _ctx.ExerciseType.COMPLETION)
          ? (_openBlock(), _createBlock(_component_Exercise, {
              key: 0,
              exercise: _ctx.exercise,
              showReadOnlyAnswer: _ctx.showAnswer,
              submission: _ctx.submission,
              readOnly: !_ctx.allowEditSubmission,
              showLabel: _ctx.showExerciseLabel,
              showSolution: _ctx.showSolutionAndScores,
              showPublicTags: _ctx.showTags,
              showHintButton: _ctx.showHintButton,
              onUpdateSubmission: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onUpdateSubmission($event))),
              onRunCode: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('runCode', _ctx.modelValue))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur', _ctx.modelValue))),
              class: "w-full"
            }, null, 8, ["exercise", "showReadOnlyAnswer", "submission", "readOnly", "showLabel", "showSolution", "showPublicTags", "showHintButton"]))
          : (_openBlock(), _createBlock(_component_ClozeExercise, {
              key: 1,
              class: "w-full",
              onUpdateSubmission: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('updateSubmission', $event))),
              slot: _ctx.modelValue,
              showScores: _ctx.showSolutionAndScores,
              readOnly: !_ctx.allowEditSubmission
            }, null, 8, ["slot", "showScores", "readOnly"])),
        (_ctx.showAssessmentCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_ParticipationSlotAssessment, {
                assessment: _ctx.assessment,
                readOnly: !_ctx.allowEditAssessment,
                expanded: _ctx.assessmentExpanded,
                writeOnly: _ctx.assessmentWriteOnly,
                onToggleExpanded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAssessmentExpanded($event))),
                onSave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSaveAssessment($event))),
                onUpdateAssessment: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onUpdateAssessment($event))),
                maxScore: _ctx.modelValue.weight,
                loading: _ctx.assessmentLoading
              }, {
                scoreTitle: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("misc.score")) + ": ", 1)
                ]),
                _: 1
              }, 8, ["assessment", "readOnly", "expanded", "writeOnly", "maxScore", "loading"])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.allowEditAssessment && (_ctx.modelValue.seen_at || _ctx.modelValue.answered_at))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.modelValue.seen_at)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("event_assessment.exercise_seen_at")) + " ", 1),
                  _createVNode(_component_Timestamp, {
                    value: _ctx.modelValue.seen_at
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.modelValue.answered_at)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("event_assessment.exercise_answered_at")) + " ", 1),
                  _createVNode(_component_Timestamp, {
                    value: _ctx.modelValue.answered_at
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.exercise.exercise_type === _ctx.ExerciseType.AGGREGATED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.sub_slots, (subSlot, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: _ctx.modelValue.id + '-sub-slot-' + subSlot.id,
                class: _normalizeClass({ 'mb-8': index !== _ctx.modelValue.sub_slots.length - 1 })
              }, [
                _createVNode(_component_AbstractEventParticipationSlot, {
                  subSlot: true,
                  modelValue: subSlot,
                  allowEditAssessment: _ctx.allowEditAssessment,
                  allowEditSubmission: _ctx.allowEditSubmission,
                  showAssessmentCard: _ctx.showAssessmentCard,
                  showSolutionAndScores: _ctx.showSolutionAndScores,
                  assessmentControlsVisibility: _ctx.assessmentControlsVisibility,
                  onRunCode: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('runCode', $event))),
                  onSetAssessmentExpanded: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('setAssessmentExpanded', $event))),
                  onUpdateAssessment: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('updateAssessment', $event))),
                  onUpdateSubmission: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('updateSubmission', $event))),
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('blur', $event))),
                  onSaveAssessment: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('saveAssessment', $event)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("event_participation_page.exercise")) + " " + _toDisplayString(_ctx.modelValue.slot_number + 1) + "." + _toDisplayString(subSlot.slot_number + 1), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "allowEditAssessment", "allowEditSubmission", "showAssessmentCard", "showSolutionAndScores", "assessmentControlsVisibility"])
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}